import { I18NConfig } from 'next/dist/server/config-shared'
import { LocaleEnum } from '@systemeio/ui'
import { UserConfig } from 'next-i18next'

const config: UserConfig & { i18n: I18NConfig } = {
  defaultNS: 'global',
  returnEmptyString: false,
  i18n: {
    defaultLocale: LocaleEnum.ENGLISH,
    locales: Object.values(LocaleEnum),
    localeDetection: false,
  },
}

export default config
